import styled from 'styled-components';

export const Main = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 16px;
`;

export const SelectionSection = styled.div<{
    isShowing?: boolean;
}>`
    display: ${({ isShowing = true }) => (isShowing ? 'flex' : 'none')};
    justify-content: space-between;
    align-items: center;
    row-gap: 16px;
`;

export const SelectionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    width: 100%;
`;
